import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7b0d4ff0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "login-container"
};
const _hoisted_2 = {
  class: "login-card"
};
const _hoisted_3 = {
  class: "banner-box"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1,
  class: "img-banner"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo-text"
}, null, -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "login-form-box"
};
const _hoisted_9 = {
  class: "login-logo"
};
const _hoisted_10 = {
  class: "login-logo-img"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "login-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoginForm = _resolveComponent("LoginForm");
  return $data.projectInfo ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [$data.loginBanner ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.loginBanner,
    class: "banner-image",
    alt: ""
  }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: $data.projectInfo.login_url
  }, null, 8, _hoisted_11)])]), _createVNode(_component_LoginForm, {
    projectInfo: $data.projectInfo
  }, null, 8, ["projectInfo"]), _createElementVNode("div", _hoisted_12, _toDisplayString($data.projectInfo.copyright), 1)])])])) : _createCommentVNode("", true);
}